export default __webpack_public_path__ + "static/media/017-tasks.c73b81fc.svg";